import {
  conditionsWithCSV,
  conditionsWithExactlyTwoValues,
  conditionsWithNoValues
} from 'modules/cohort-browser/components/phenotypic-data-discovery/table-discovery/filters/utils'
import type {
  ChipData,
  DiscoveryTableFilterCondition,
  DiscoveryTableFilterWithConditions
} from 'modules/cohort-browser/components/query/preview-query/types'
import { ColumnDataType, Conditions } from 'modules/cohort-browser/enums'

interface ChipContentProps {
  filter: DiscoveryTableFilterWithConditions
  columnType: ColumnDataType
}

interface ConditionContentProps {
  condition: DiscoveryTableFilterCondition
}

const ConditionContent = ({ condition }: ConditionContentProps): ChipData[] => {
  if (conditionsWithNoValues.includes(condition.type as Conditions)) {
    return [{ type: 'value', value: condition.type }]
  }

  if (conditionsWithExactlyTwoValues.includes(condition.type as Conditions)) {
    return [
      { type: 'operator', value: condition.type },
      { type: 'value', value: condition.values?.[0] ?? '' },
      { type: 'operator', value: 'AND' },
      { type: 'value', value: condition.values?.[1] ?? '' }
    ]
  }

  if (conditionsWithCSV.includes(condition.type as Conditions)) {
    return [
      { type: 'operator', value: condition.type },
      { type: 'value', value: condition.values?.join(', ') ?? '' }
    ]
  }

  return [
    { type: 'operator', value: condition.type },
    { type: 'value', value: condition.values?.[0] ?? '' }
  ]
}

const ChipContent = ({ filter }: ChipContentProps): ChipData[] => {
  const firstCondition = filter.conditions?.[0]

  if (!firstCondition) {
    return []
  }

  const secondCondition = filter.conditions?.[1]
  const secondConditionContent: ChipData[] = secondCondition
    ? [{ type: 'operator', value: filter.operator || '' }, ...ConditionContent({ condition: secondCondition })]
    : []

  return [
    { type: 'text', value: filter.column },
    ...ConditionContent({ condition: firstCondition }),
    ...secondConditionContent
  ]
}

export default ChipContent
